import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from './shared/AppSettings';

@Injectable()
export class TransferDataService {
  readonly rootUrl = AppSettings.webApiURL;

  constructor(public httpClient: HttpClient) { }

  getBuildDate(customerId) {
    return this.httpClient.get(`${this.rootUrl}/api/TransferDetailApi/GetBuildDate?customerId=${customerId}`);
  }
  getReportResult(toDate, fromDate, customerId, fundInstitutionId, ReportType, dateType) {
    return this.httpClient.get(`${this.rootUrl}/api/TransferDetailApi/GetReport?toDate=${toDate}&fromDate=${fromDate} &customerId=${customerId} &fundInstitutionId=${fundInstitutionId}&ReportType=${ReportType}&dateType=${dateType}`);
  }
  getCustomers() {
    return this.httpClient.get(`${this.rootUrl}/api/TransferDetailApi/GetCustomers`);
  }
  getFundInstitution(customerId) {
    return this.httpClient.get(`${this.rootUrl}/api/TransferDetailApi/GetFundInstitution?customerId=${customerId}`);
  }
  getCustomerDetail(customerId) {
    return this.httpClient.get(`${this.rootUrl}/api/TransferDetailApi/GetCustomerDetail?customerId=${customerId}`);
  }
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/transfer-data.service.ts